import { toExcelAmount, toExcelDate, toExcelInteger } from 'components/xlsx/excelCells';
import { getDaysOverdue } from 'pages/invoices/util/invoiceUtil';
import { InvoiceExportListItemDto } from 'types/invoices';
import { t } from 'utils/getTranslations';

export const mapInvoicesToCRFormat = (invoices: InvoiceExportListItemDto[]) => {
    return invoices?.map((invoice) => {
        const currTypePayment = t('invoices.export.currency-type.payment');

        return {
            [t('invoices.export.issued-by-office')]: invoice.issuedByOffice,
            [t('invoices.export.date-of-invoice')]: toExcelDate(invoice.invoiceDate),
            [t('invoices.export.due-date')]: toExcelDate(invoice.dueDate),
            [t('invoices.export.days-overdue')]: toExcelInteger(getDaysOverdue(invoice.dueDate)),
            [t('invoices.export.invoice-number')]: invoice.invoiceNumber,
            [t('invoices.export.payer-name')]: invoice.payer.name,
            [t('invoices.export.client-name')]: invoice.clientParties?.map(({ name }) => name).join(', '),
            [t('invoices.export.primary-contact-name')]: invoice.primaryContacts?.map(({ name }) => name).join(', '),
            [t('invoices.export.issued-for-cases')]: invoice.issuedForCases?.map(({ name }) => name).join(', '),
            [t('invoices.export.currency', { currencyType: currTypePayment })]: invoice.paymentCurrencyTypeCode,
            [t('invoices.export.total-amount', { currencyType: currTypePayment })]: toExcelAmount(
                invoice.totalsPaymentCurrency?.totalAmount
            ),
            [t('invoices.export.prepayment', { currencyType: currTypePayment })]: toExcelAmount(
                invoice.totalsPaymentCurrency?.prepayment
            ),
            [t('invoices.export.payable-amount-prepayment-deducted', { currencyType: currTypePayment })]: toExcelAmount(
                invoice.totalsPaymentCurrency?.payableAmount
            ),
            [t('invoices.export.paid-on-date')]: toExcelDate(invoice.paidOnDate),
            [t('invoices.export.remains-unpaid', { currencyType: currTypePayment })]: toExcelAmount(
                invoice.totalsPaymentCurrency?.remainsUnpaid
            ),
            [t('invoices.export.debt-collection-notes')]: invoice.debtNotes,
        };
    });
};
